import PropTypes from "prop-types";

import {
  countdownCss,
  dateCss,
  dateRangeCss,
  newCountdownCss,
  newDateCss,
  newDateRangeCss,
} from "./ChallengeCountdown.style";

const propTypes = {
  countdown: PropTypes.number,
  date: PropTypes.number,
  month: PropTypes.string,
  useNewLayout: PropTypes.boolean,
};

const ChallengeCountdown = ({
  month,
  date,
  countdown,
  useNewLayout = false,
}) => {
  const countdownLabel = `Closes ${countdown > 0 ? "in " + countdown + (countdown > 1 ? " days" : " day") : "today"}`;
  const minWidth =
    countdown === 0 ? "100px" : countdown > 10 ? "123px" : "111px";

  return (
    <>
      {useNewLayout ? (
        <div css={newDateRangeCss}>
          <div css={newCountdownCss} style={{ minWidth }}>
            {countdownLabel}
          </div>
          <div css={newDateCss}>
            {month}
            <span>{date}</span>
          </div>
        </div>
      ) : (
        <div css={dateRangeCss}>
          <div css={dateCss}>
            {month}
            <span>{date}</span>
          </div>
          <div css={countdownCss}>{countdownLabel} </div>
        </div>
      )}
    </>
  );
};

ChallengeCountdown.propTypes = propTypes;

export default ChallengeCountdown;
